/**
 * Project Panel
 *
 * Created by stefensuhat on 26/07/18 2.29 PM
 */

import { blue } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
import { dark, divider } from 'utils/theme/colorsDark';
import * as colors from './theme/colorsDark';
import fonts from './theme/fonts';
import typography from './theme/typography';

const palette = {
    ...colors,
    type: 'dark',
};

// eslint-disable-next-line import/no-mutable-exports
let theme = createMuiTheme({
    palette,
    typography,
    shape: { borderRadius: 10 },
    width: { drawerLeft: 225, drawerRight: 350 },
});

theme = {
    ...theme,
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [fonts],
            },
        },
        // MuiDrawer: {
        //     paper: {
        //         backgroundColor: dark,
        //     },
        // },
        MuiButton: {
            contained: {
                backgroundColor: '#FFF',
            },
        },
        MuiFab: {
            root: {
                backgroundColor: '#FFF',
            },
        },
        // MuiTable: {
        //     root: {
        //         fontFamily: theme.typography.fontFamily,
        //     },
        // },
        MuiTablePagination: {
            caption: {
                fontSize: theme.typography.subtitle2.fontSize,
                // color: 'white',
            },
        },
        MuiTabs: {
            root: {
                marginLeft: theme.spacing(1),
                borderBottom: `1px solid ${theme.palette.divider}`,
            },
            indicator: {
                height: 3,
                borderTopLeftRadius: 3,
                borderTopRightRadius: 3,
            },
        },
        MuiTab: {
            root: {
                textTransform: 'initial',
                margin: '0 16px',
                minWidth: 0,
                [theme.breakpoints.up('md')]: {
                    minWidth: 0,
                },
            },
            labelIcon: {
                padding: 0,
                [theme.breakpoints.up('md')]: {
                    padding: 0,
                },
            },
        },
        MuiIconButton: {
            root: {
                padding: theme.spacing(1),
            },
        },
        MuiTooltip: {
            tooltip: {
                borderRadius: 4,
            },
        },
        // MuiDivider: {
        //     root: {
        //         backgroundColor: '#404854',
        //     },
        // },
        MuiListItemText: {
            primary: {
                fontWeight: theme.typography.fontWeightMedium,
            },
        },
        MuiListItemIcon: {
            root: {
                color: 'inherit',
                marginRight: 0,
                '& svg': {
                    fontSize: 20,
                },
            },
        },
        MuiAvatar: {
            root: {
                width: 32,
                height: 32,
            },
        },
        MuiCardMedia: {
            root: {
                borderRadius: theme.shape.borderRadius,
                // backgroundColor: '#ddd',
                // backgroundImage: `url(${loading})`,

            },
        },
        MuiCardActions: {
            root: {
                borderTop: `1px solid ${theme.palette.divider}`,
            },
        },
        // MuiDialogContent: {
        //     root: {
        //         padding: theme.spacing(1,2),
        //     },
        // },
        MuiDialogActions: {
            root: {
                margin: 0,
                padding: theme.spacing(1),
            },
        },
        MuiInput: {
            underline: {
                '&:before': {
                    borderBottomColor: theme.palette.divider,
                },
                '&:after': {
                    borderBottomColor: theme.palette.type === 'light' ? '#151515' : '#C2C2C2',
                },
            },
        },
        MuiFilledInput: {
            underline: {
                '&:after': {
                    borderBottomColor: theme.palette.type === 'light' ? '#151515' : '#C2C2C2',
                },
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: `1px solid ${divider}`,
            },
        },
        MuiOutlinedInput: {
            root: {
                '& $notchedOutline': {
                    borderColor: theme.palette.divider,
                },
                '&$focused $notchedOutline': {
                    borderColor: theme.palette.type === 'light' ? '#151515' : '#C2C2C2',
                },
            },
        },
        MuiFormLabel: {
            root: {
                '&$focused': {
                    color: theme.palette.type === 'light' ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255, 0.6)',
                },
            },
        },
        MuiPickersModal: {
            dialogRoot: { padding: 0 },
        },
        MuiRadio: {
            root: {
                padding: theme.spacing(1),
                color: blue[600],

                '&$checked': {
                    color: blue[500],
                },
            },
            colorPrimary: {
                padding: theme.spacing(1),
                color: blue[600],
                '&$checked': {
                    color: blue[500],
                },
            },
            colorSecondary: {
                padding: theme.spacing(1),
                color: blue[600],
                '&$checked': {
                    color: blue[500],
                },
            },
            checked: {},
        },
        props: {
            MuiTab: {
                disableRipple: true,
            },
        },

        mixins: {
            ...theme.mixins,
            toolbar: {
                minHeight: 48,
            },
        },
    },

};

export default theme;
